import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="dark-header">
      <Link to="/" className="logo-container">
        <img src="/eaet-logo.svg" alt="EAET" className="logo-image" />
      </Link>

      <nav className="dark-nav">
        <Link 
          to="/agents" 
          className={`dark-nav-link ${isActive('/agents') ? 'active' : ''}`}
        >
          Agents
        </Link>
        <Link 
          to="/platform" 
          className={`dark-nav-link ${isActive('/platform') ? 'active' : ''}`}
        >
          How It Works
        </Link>
        <Link 
          to="/solutions" 
          className={`dark-nav-link ${isActive('/solutions') ? 'active' : ''}`}
        >
          Solutions
        </Link>
        <Link 
          to="/pricing" 
          className={`dark-nav-link ${isActive('/pricing') ? 'active' : ''}`}
        >
          Pricing
        </Link>
        <Link 
          to="/blog" 
          className={`dark-nav-link ${isActive('/blog') ? 'active' : ''}`}
        >
          Resources
        </Link>
        <Link to="/demo" className="btn-primary">
          Request Access
        </Link>
      </nav>

      <button 
        className="mobile-menu-button"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <Link to="/agents" onClick={() => setMobileMenuOpen(false)}>Agents</Link>
          <Link to="/platform" onClick={() => setMobileMenuOpen(false)}>How It Works</Link>
          <Link to="/solutions" onClick={() => setMobileMenuOpen(false)}>Solutions</Link>
          <Link to="/pricing" onClick={() => setMobileMenuOpen(false)}>Pricing</Link>
          <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>Resources</Link>
          <Link to="/demo" className="btn-primary" onClick={() => setMobileMenuOpen(false)}>
            Request Access
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;